<div class="define-sop-wrapper" #sopWrapper [hidden]="!service.isCollapsed" id="collapseExample">
    <div class="define-single-sop">
        <span #arrw class="arrw"></span>
        <span #arrwShadow class="arrwShadow"></span>
        <a class="btn-close" (click)=" updateSingleSOP()" *ngIf='isDesktop'><img src="assets/ph-bhp-sopmanagement/SOP-Images/close.svg"></a>
        <div class="m-4">
            <div class="row m-0">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ 'SOP_MANAGEMENT.DEFINE_STEP' | translate }}</label>
                        <div>
                            <div class="custom-control custom-radio custom-control-inline mt-2 p-0">
                                <input [attr.disabled]="(viewType == 'view')?false:null" type="radio" id="customRadioInline1" name="customRadioInline11" class="custom-control-input" checked="" [value]="false" [(ngModel)]="sopStep.stepType" (click)="stepTypeRadio(false)">
                                <label class="custom-control-label1" for="customRadioInline1">{{ 'SOP_MANAGEMENT.SINGLE_STEP' | translate }}</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input [attr.disabled]="(viewType == 'view')?false:null || (service.subStepDisable == true && !sopStep.stepType)?false:null" type="radio" id="customRadioInline2" name="customRadioInline11" class="custom-control-input" [value]="true" [(ngModel)]="sopStep.stepType"
                                    (click)="stepTypeRadio(true)">
                                <label class="custom-control-label1" for="customRadioInline2">{{ 'SOP_MANAGEMENT.SUB_PROCESS' | translate }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="sopStep.stepType">
                    <div (click)="openTranslationModal(sopStep.stepName,'SOP_MANAGEMENT.TITLE_SUB_PROCESS')" class="form-group">
                        <label>{{ 'SOP_MANAGEMENT.TITLE_SUB_PROCESS' | translate }}</label>
                        <input readonly type="button" maxlength="150" class="form-control text-left text-truncate" placeholder="{{'SOP_MANAGEMENT.TITLE_SUB_PROCESS' | translate}} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 150 ) " [ngModel]="layoutService.translateText(sopStep.stepName)"
                            [ngClass]="{'is-invalid': isSubprocessTitleInvalid && updateSubmitted}">
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row" *ngFor="let item of sopStep.stepCards;let i = index">
                        <div class="col-md-6">
                            <div class="form-group" (click)="openTranslationModal(item.stepTittle, 'SOP_MANAGEMENT.STEP_TITLE')">
                                <label>{{ 'SOP_MANAGEMENT.STEP_TITLE' | translate }} {{1+i}}</label>
                                <input readonly #modelStepTittle="ngModel" type="button" maxlength="150" placeholder="{{'SOP_MANAGEMENT.STEP_TITLE' | translate }} ({{'INSTITUTION_MANAGEMENT.MAX' | translate}} 150)" class="form-control text-left text-truncate" [ngModel]="layoutService.translateText(item.stepTittle)"
                                    [ngClass]="{'is-invalid':modelStepTittle.errors && (modelStepTittle.touched || modelStepTittle.dirty|| updateSubmitted)}">
                                <div class="form-control-descrition-msgs">
                                    <div class="invalid-feedback" *ngIf="modelStepTittle.errors && (modelStepTittle.touched || modelStepTittle.dirty || updateSubmitted)">
                                        <span *ngIf="modelStepTittle.errors.required">
                            {{ 'ERROR_MESSAGES.REQUIRED.STEP_TITLE_2' | translate }}
                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-5 col-lg-4 mt-5 pl-0">
                                    <div class="card-task" (click)="openModal(i)">
                                        <div class="card-task-media">
                                            <img [ngClass]="[(item.stepImage)?'svg img-fluid':'no-image', (item.isInstitutionImage)?'imgFilter':'']" [src]="(item.stepImage)?layoutService.serverUrl +item.stepImage :'assets/ph-bhp-layout/svg/no-image.png'">
                                        </div>
                                    </div>
                                    <div class="uploadImgTxt justify-content-center mt-2 d-flex" *ngIf="viewType != 'view'">
                                        <span *ngIf="item.stepImage" (click)="openModal(i)">{{ 'CONFIGURE.EDIT' | translate }}</span>
                                        <span *ngIf="item.stepImage" (click)="openDeleteImageModal(delImageModal,i);">{{ 'LAYOUT_MODULE.REMOVE' | translate }}</span>
                                        <span *ngIf="!item.stepImage" (click)="openModal(i)">{{ 'SOP_MANAGEMENT.ADD_IMAGE' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" *ngIf="sopStep.stepType && viewType != 'view'">
                                <div>
                                    <div class="col-12 custom-control custom-radio custom-control-inline p-4 mt-2">
                                        <input [attr.disabled]="(viewType == 'view')?false:null" type="radio" id="useInStepImage-{{i}}" name="useInStepImage" class="custom-control-input" [value]="i" [(ngModel)]="sopStep.useStepImage" (change)="commonChecked()">
                                        <label for="useInStepImage-{{i}}">{{ 'SOP_MANAGEMENT.USE_AS_DEFAULT_IMAGE' | translate }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{ 'SOP_MANAGEMENT.OPTIONS' | translate }}</label>
                                <div>
                                    <div class="col-12 custom-control custom-radio custom-control-inline p-0 mt-2">
                                        <input [attr.disabled]="(viewType == 'view')?false:null" type="checkbox" id="customRadioInline3-{{i}}" name="customRadioInline21-{{i}}" class="custom-control-input" checked="" [value]="true" [(ngModel)]="item.handDisinfection" (change)="commonChecked()">
                                        <label for="customRadioInline3-{{i}}">{{ 'SOP_MANAGEMENT.INDICATIONS_FOR_HAND_DISINFECTION' | translate }}</label>
                                    </div>
                                    <div class="form-group mt-2" *ngIf="item.handDisinfection">
                                        <div class="sop-box p-3">
                                            <div class="">
                                                <div class="mb-2" *ngFor="let handDisinfectionIndicater of handDisinfectionIndicators;let j = index">
                                                    <input [attr.disabled]="(viewType == 'view')?false:null" type="checkbox" class="custom-control-input" [(ngModel)]="item.indications[handDisinfectionIndicater.key]" value="{{handDisinfectionIndicater.value}}" id="customHandDisinfectionCheck1{{i}}-{{j}}"
                                                        (change)="commonChecked()">
                                                    <label for="customHandDisinfectionCheck1{{i}}-{{j}}">{{handDisinfectionIndicater.value | translate}}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 custom-control custom-radio custom-control-inline p-0 mt-2">
                                        <input [attr.disabled]="(viewType == 'view')?false:null" type="checkbox" id="customRadioInline5-{{i}}" name="customRadioInline21-{{i}}" class="custom-control-input" [value]="true" [(ngModel)]="item.hygieneRelevantStep" (change)="commonChecked()">
                                        <label for="customRadioInline5-{{i}}">{{ 'SOP_MANAGEMENT.HYGIENE_RELEVANT_STEP' | translate }}</label>
                                    </div>
                                    <div class="col-12 custom-control custom-radio custom-control-inline p-0 mt-2">
                                        <input [attr.disabled]="(viewType == 'view')?false:null" type="checkbox" id="customRadioInline4-{{i}}" name="customRadioInline21-{{i}}" class="custom-control-input" [value]="true" [(ngModel)]="item.situational" (change)="commonChecked()">
                                        <label for="customRadioInline4-{{i}}">{{ 'SOP_MANAGEMENT.SITUATIONAL' | translate }}</label>
                                    </div>
                                    <div class="form-group mt-2" *ngIf="item.situational">
                                        <div class="form-control-descrition-msgs">
                                            <textarea readonly class="form-textarea form-control" (click)="openTranslationModal(item.comments, 'CONFIGURE.COMMENTS', true, situationalCommentsMaxLength)" maxlength="{{situationalCommentsMaxLength}}" rows="5" placeholder="{{ 'CONFIGURE.WRITE_COMMENTS_HERE' | translate }}"
                                                [ngModel]="layoutService.translateText(item.comments)"></textarea>
                                            <button type="button" class="btn btn-block btn-primary" (click)="openTranslationModal(item.comments, 'CONFIGURE.COMMENTS', true, situationalCommentsMaxLength)">
                          {{ 'SOP_MANAGEMENT.TRANSLATE_BUTTON' | translate }}
                      </button>
                                            <span class="character-count-text">{{(item.comments)?item.comments.length :
                          '0'}}
                          /
                          {{situationalCommentsMaxLength}} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="form-group" *ngIf="sopStep.stepType && viewType != 'view'">
                                <button class="btn btn-primary-delete" (click)="openSubDeleteModal(subdelmodal, i)">
                  {{ 'SOP_MANAGEMENT.DELETE_STEP' | translate }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="sopStep.stepType && viewType != 'view'">
                        <div class="col-md-12 mt-5">
                            <button class="btn btn-outline-primary" (click)="addStack()">
                <img class="mr-3"
                  src="assets/ph-bhp-layout/svg/icon-add.svg">{{ 'SOP_MANAGEMENT.ADD_STEP' | translate }}
              </button>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row m-0 justify-content-between mt-4 mb-4" *ngIf="viewType != 'view'">
                <div class="col-auto d-flex mt-5">
                    <!-- <a href="#" class="btn btn-primary mr-4">Save</a> -->
                    <!--
          <button class="btn btn-primary mr-4" (click)="saveSingleSOP()"
            *ngIf="!isUpdate">{{ translationKeys.Authorization.Save | translate }}</button>
          <button class="btn btn-primary mr-4" (click)="updateSingleSOP()"
            *ngIf="isUpdate">{{ translationKeys.Observation.Update | translate }}</button>
-->
                    <button class="btn btn-primary-delete" (click)="openDeleteModal(delmodal)">
            {{(sopStep.stepType)? ('SOP_MANAGEMENT.DELETE_SUB_PROCESS'| translate) : ('SOP_MANAGEMENT.DELETE_STEP' | translate)}}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal - Image Library -->
<!-- TODO extract image library modal -->
<ng-template #template class="modal-changeLang">
    <div class="d-flex justify-content-between align-items-center p-3">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'SOP_MANAGEMENT.LIBRARY' | translate }}</h5>
        <a (click)="cancelChooseImage();" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="px-3 imageLibrary">
        <tabset>
            <tab heading="{{ 'SOP_MANAGEMENT.HARTMANN_LIBRARY' | translate }}" id="tab1">
                <div class="tab-content my-3">
                    <div class="">
                        <input inputSanitizer type="text" class="w-100 form-control search-input" [(ngModel)]="searchText" (ngModelChange)="displayNone($event)" placeholder="{{ 'SOP_MANAGEMENT.SEARCH_IMAGE' | translate }}..." />
                        <div class="box-container h-auto mt-3 tooltipMaskMob" [ngClass]="tooltipcloseMob?'active':''" >
                            <div class="grid-library"><!-- <div class="row ms-auto"> -->
                                <!--<div class="image-card col-auto p-0" *ngFor="let image of ImageData| search:searchText; let j = index">-->
                                <div id="image-hartmann-{{j + 1}}" class="image-card" [ngStyle]=" { 'grid-row': ((j+1)%5) === 0 && activeClass[j] ? (j+1)/5 : ''}" [ngClass]="(activeClass[j])?'active-'+j%5:''" *ngFor="let image of ImageData| search:searchText; let j = index">
                                    <div class="card-task card-task-small" [ngClass]="(activeClass[j])?'active':''" (click)="selectImage(image, j, $event)">
                                        <div class="card-task-media">
                                            <a>
                                                <img [ngClass]="image.imageURL?'svg img-fluid':'no-image'"
                                                [src]="image.imageURL?layoutService.serverUrl +image.imageURL :'assets/img/fallback-img.png'"
                                                (error)="errImg($event)">
                                            </a>
                                        </div>

                                        <div class="card-task-popover" *ngIf="activeClass[j]">
                                            <!--<span class="published">{{ 'CONFIGURE.IMAGE_NAME' | translate }} </span>-->
                                            <h5 class="mb-3 card-task-title">{{tooltipImage.imageName | translate}}</h5>
                                            <!--<span class="published">{{'SOP_MANAGEMENT.DESCRIPTION' | translate}}</span>-->
                                            <h5 class="mb-3 card-task-title">{{tooltipImage.description | translate}}</h5>
                                            <!--<span class="published">{{ 'SOP_MANAGEMENT.TAG' | translate }}</span>-->
                                            <ul class="advise-container">
                                                <li id="tag-{{j + 1}}" *ngFor="let tags of tooltipImage.tags; let j = index">
                                                    {{tags.value | translate}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab heading="{{ 'CONFIGURE.INSTITUTION_LIBRARY' | translate }}" id="tab2" *ngIf="institutionID != null">
                <div class="tab-content my-3">
                    <div class="">
                        <input inputSanitizer type="text" class="form-control search-input" (ngModelChange)="displayNone($event)" [(ngModel)]="searchText" placeholder="{{ 'SOP_MANAGEMENT.SEARCH_IMAGE' | translate }}..." />
                        <div class="box-container2 h-auto tooltipMaskMob mt-3" [ngClass]="tooltipcloseMob?'active':''" data-simplebar>
                            <!--<div class="row ms-auto">-->
                            <div class="grid-library">
                                <!--<div class="col-auto p-0" *ngIf='showAddImage'>-->
                                <div class="card-task m-0 w-100 h-100" (click)="openCamera()" *ngIf='showAddImage'>
                                    <div class="card-task-media addNew">
                                        <img class="no-image" src='assets/ph-bhp-configuration/svg/icon-plus.svg'>
                                        <span>{{ 'SOP_MANAGEMENT.ADD_IMAGE' | translate }}</span>
                                    </div>
                                </div>
                                <!--<div class="image-card col-auto p-0" *ngFor="let image of InstitutionImageData| search:searchText; let j = index">--><!--[ngStyle]=" { 'grid-row': ((j+1)%5) === 0 && activeClass[j] ? (j+1)/5 : ''}"-->
                                <div id="image-institution-{{j + 1}}" class="image-card" [attr.value-j]="j" [ngStyle]=" showAddImage ? {'grid-row': ((j+2)%5) === 0 && activeClass[j] ? (j+2)/5 : ''} : {'grid-row': ((j+1)%5) === 0 && activeClass[j] ? (j+1)/5 : ''} "  [ngClass]="activeClass[j] ? 'active-'+ (showAddImage ? (j%5)+1 : j%5 ) : ''" *ngFor="let image of InstitutionImageData| search:searchText;  let j = index ">
                                    <div class="card-task card-task-small" [ngClass]="(activeClass[j])?'active':''" (click)="selectUserImage(image, j, $event)">
                                        <div class="card-task-media">
                                            <a>
                                                <img class="imgFilter" [ngClass]="image.imageURL?'svg img-fluid':'no-image'"
                                                [src]="image.imageURL?layoutService.serverUrl +image.imageURL :'assets/img/fallback-img.png'"
                                                (error)="errImg($event)">
                                            </a>
                                        </div>

                                        <div class="card-task-popover" *ngIf="activeClass[j]">
                                            <span class="published">{{ 'CONFIGURE.IMAGE_NAME' | translate }} </span>
                                            <h5 class="mb-3 card-task-title">{{tooltipImage.imageName | translate}}</h5>
                                            <span class="published">{{ 'CONFIGURE.DESCRIPTION' | translate }}</span>
                                            <h5 class="mb-3 card-task-title">{{tooltipImage.description | translate}}</h5>
                                            <span class="published">{{ 'SOP_MANAGEMENT.TAG' | translate }}</span>
                                            <ul class="advise-container">
                                                <li id="tag-{{j + 1}}" *ngFor="let tags of tooltipImage.tags; let j = index">{{tags.value}}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabset>
    </div>
    <div class="modal-footer p-3">
        <div class="p-0 m-0">
        <div class="justify-content-end align-items-end d-flex">
                <button (click)="cancelChooseImage();" class="btn-cancel-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
                <button type="button" class="btn-continue-bordered-bd" (click)="chooseImage()">{{ 'CONFIGURE.CHOOSE_IMAGE' | translate }}</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #delmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.STEP' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="removeSOP();modalRef.hide();" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #subdelmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'SOP_MANAGEMENT.CONFIRMATION_DELETE_SUB_PROCESS' | translate }} </p>
        <p *ngIf="sopStep.stepCards.length == 2">
            {{ 'CONFIRMATION_MOVE_TO_SINGLE_STEP_LOSS_OF_SUB_PROCESS_STEPS' | translate}}
        </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'INSTITUTION_MANAGEMENT.NO' | translate }}</button>
            <button (click)="deleteSubProcess();modalRef.hide();" class="btn-bd-empty">{{ 'INSTITUTION_MANAGEMENT.YES' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #delImageModal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'SOP_MANAGEMENT.CONFIRMATION_DELETE_IMAGE' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="deleteImage();modalRef.hide();" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #confirmModal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="retainsinglestep();modalRef2.hide()"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'SOP_MANAGEMENT.CONFIRMATION_MOVE_TO_SINGLE_STEP_LOSS_OF_SUB_PROCESS_STEPS' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="retainsubprocess();modalRef2.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="retainsinglestep();modalRef2.hide();" class="btn-bd-empty">{{ 'AUTHORIZATION.CHANGE' | translate }}</button>
        </div>
    </div>
</ng-template>
